.classSpellsForm {
  .selectLabel {
    display: block;
    margin-bottom: 8px;
    font-weight: bold;
  }

  fieldset {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: repeat(5, 1fr);
    grid-auto-flow: column;
    border: none;
    margin: 16px 0;
    padding: 0;

    legend {
      margin-bottom: 8px;
      font-weight: bold;
    }
  }
}
